import React from 'react';
import { Box, Typography } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import Barcode from 'react-barcode';

const PoojaOrderCodes = ({ booking }) => {
  if (!booking) return null;

  const qrData = JSON.stringify({
    id: booking._id,
    pujaName: booking.pujaName || booking.pujaType,
    pujaType: booking.pujaType,
    amount: booking.amount,
    status: booking.status,
    date: booking.date,
    time: booking.time,
    customer: booking.userId?.name || '',
    email: booking.userId?.email || '',
    phone: booking.userId?.phone || '',
    astrologer: booking.astrologerId?.name || '',
    participants: booking.participants?.length || 0,
    notes: booking.notes || '',
    bookedOn: booking.createdAt,
  });

  return (
    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>QR Code</Typography>
        <Box sx={{ bgcolor: '#fff', p: 1, borderRadius: 1, border: '1px solid #e0e0e0', display: 'inline-block' }}>
          <QRCodeSVG value={qrData} size={100} />
        </Box>
      </Box>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>Barcode</Typography>
        <Box sx={{ bgcolor: '#fff', p: 1, borderRadius: 1, border: '1px solid #e0e0e0', display: 'inline-block' }}>
          <Barcode value={booking._id} height={40} width={1.5} fontSize={11} margin={0} />
        </Box>
      </Box>
    </Box>
  );
};

export default PoojaOrderCodes;
